export enum PrivacyConsentValues {
  CONSENT_NEEDED = '290920000',
  NOT_APPLICABLE = '290920003',
  CONSENT_ACCEPTED = '290920002',
  CONSENT_REJECTED = '290920001',
}
